import { useState, useEffect } from 'react'
import { Routes, Route, Navigate } from 'react-router-dom'
import LoginPage from './pages/LoginPage'
import Layout from './components/Layout'
import api from './services/api'
import Principal from './pages/Principal'
import Documents from './pages/Documents'
import DocumentDetail from './pages/DocumentDetail'
import EmitirNFe from './pages/EmitirNFe'
import ListaNFe from './pages/ListaNFe'
import EmitirCTeOS from './pages/EmitirCTeOS'
import ListaCTeOS from './pages/ListaCTeOS'
import Configuracoes from './pages/Configuracoes'
import CadastroClientes from './pages/CadastroClientes'
import EstornoNotaFiscal from './pages/EstornoNotaFiscal'
import ImportarNFe from './pages/ImportarNFe'
import ImportarCTe from './pages/ImportarCTe'
import ConsultaNotas from './pages/ConsultaNotas'
import ConsultaItens from './pages/ConsultaItens'
import AlterarDataNotaFiscal from './pages/AlterarDataNotaFiscal'
import AlterarCfopNotaFiscal from './pages/AlterarCfopNotaFiscal'
import AlterarAplicacaoNotaFiscal from './pages/AlterarAplicacaoNotaFiscal'
import EmissaoCodigosBarras from './pages/EmissaoCodigosBarras'
import GravarXmlNFe from './pages/GravarXmlNFe'
import RelatorioNotasComprasRecebimentoEmissao from './pages/RelatorioNotasComprasRecebimentoEmissao'
import RelatorioNotasImpostoRetido from './pages/RelatorioNotasImpostoRetido'
import RelatorioNotasEntrada from './pages/RelatorioNotasEntrada'
import RelatorioItensDevolvidos from './pages/RelatorioItensDevolvidos'
import NaturezasOperacao from './pages/NaturezasOperacao'
import LogSistema from './pages/LogSistema'
import ReformaTributaria from './pages/ReformaTributaria'
import Tributacoes from './pages/Tributacoes'
import EmitirDevolucaoNFe from './pages/EmitirDevolucaoNFe'
import EmitirNotaCreditoNFe from './pages/EmitirNotaCreditoNFe'
import EmitirNotaDebitoNFe from './pages/EmitirNotaDebitoNFe'
import AceiteDebitoNFe from './pages/AceiteDebitoNFe'
import EmitirNFSe from './pages/EmitirNFSe'
import EmitirNFSeLocacao from './pages/EmitirNFSeLocacao'
import ListaNFSeNacional from './pages/ListaNFSeNacional'
import CadastroServicosNFSe from './pages/CadastroServicosNFSe'
import CadastroTributacaoMunicipalNFSe from './pages/CadastroTributacaoMunicipalNFSe'
import EmitirNFSeInfisc from './pages/EmitirNFSeInfisc'
import ListaNFSeInfisc from './pages/ListaNFSeInfisc'
import RelatorioNfeSaida from './pages/RelatorioNfeSaida'
import DownloadLoteNotas from './pages/DownloadLoteNotas'
import RelatorioFaturamento from './pages/RelatorioFaturamento'
import RelatorioIssqn from './pages/RelatorioIssqn'
import RelatorioFaturamentoCliente from './pages/RelatorioFaturamentoCliente'
import RelatorioEvolucaoFaturamento from './pages/RelatorioEvolucaoFaturamento'
import RelatorioContasReceber from './pages/RelatorioContasReceber'
import CadastroFuncionarios from './pages/CadastroFuncionarios'
import ImportarDespesasFuncionarios from './pages/ImportarDespesasFuncionarios'
import CadastroPlanosSaude from './pages/CadastroPlanosSaude'
import CertificadosRegistros from './pages/CertificadosRegistros'
import CategoriasCnh from './pages/CategoriasCnh'
import Ocorrencias from './pages/Ocorrencias'
import Afastamentos from './pages/Afastamentos'
import LocaisEscala from './pages/LocaisEscala'
import CategoriasProfissionais from './pages/CategoriasProfissionais'
import RelatorioCustoPlanoSaude from './pages/RelatorioCustoPlanoSaude'
import RelatorioFuncionarios from './pages/RelatorioFuncionarios'
import RelatorioFuncionariosAfastados from './pages/RelatorioFuncionariosAfastados'
import RelatorioSalariosAtuais from './pages/RelatorioSalariosAtuais'
import GeradorRelatorios from './pages/GeradorRelatorios'
import RelatorioValidadeExames from './pages/RelatorioValidadeExames'
import RelatorioVencimentoCnh from './pages/RelatorioVencimentoCnh'
import RelatorioAniversariantes from './pages/RelatorioAniversariantes'
import ControleFerias from './pages/ControleFerias'
import CalendarioFerias from './pages/CalendarioFerias'
import RelatorioVencimentoCertificados from './pages/RelatorioVencimentoCertificados'
import PainelVencimentosFuncionarios from './pages/PainelVencimentosFuncionarios'
import LancamentoOcorrencias from './pages/LancamentoOcorrencias'
import ExcluirOcorrencias from './pages/ExcluirOcorrencias'
import FichaPonto from './pages/FichaPonto'
import NovaFichaPonto from './pages/NovaFichaPonto'
import AbrirFichasLote from './pages/AbrirFichasLote'
import ImportarBusrepLote from './pages/ImportarBusrepLote'
import ExcluirFichasLote from './pages/ExcluirFichasLote'
import ImprimirFichasLote from './pages/ImprimirFichasLote'
import CartaoPontoDias from './pages/CartaoPontoDias'
import ParametrosFichaPonto from './pages/ParametrosFichaPonto'
import TiposJornada from './pages/TiposJornada'
import CadastroColaboradores from './pages/CadastroColaboradores'
import LancamentoDepositos from './pages/LancamentoDepositos'
import LancamentosExternos from './pages/LancamentosExternos'
import AtualizarLancamentosVeiculo from './pages/AtualizarLancamentosVeiculo'
import RelatorioConsumoArla from './pages/RelatorioConsumoArla'
import RelatorioConsumoFrota from './pages/RelatorioConsumoFrota'
import RelatorioMediaCombustivel from './pages/RelatorioMediaCombustivel'
import RelatorioLancamentosDia from './pages/RelatorioLancamentosDia'
import RelatorioConsumoMensalVeiculo from './pages/RelatorioConsumoMensalVeiculo'
import RelatorioConsumoPosto from './pages/RelatorioConsumoPosto'
import RelatorioAbastecedor from './pages/RelatorioAbastecedor'
import IntegracaoCtaPlus from './pages/IntegracaoCtaPlus'
import SaldoTanques from './pages/SaldoTanques'
import PainelCombustivel from './pages/PainelCombustivel'
import CorrigeLancamentosImportacao from './pages/CorrigeLancamentosImportacao'
import RelatorioDesvioConsumo from './pages/RelatorioDesvioConsumo'
import CadastroCombustiveis from './pages/CadastroCombustiveis'
import CadastroPostos from './pages/CadastroPostos'
import LayoutPostos from './pages/LayoutPostos'
import MotivosDivergenciaMedia from './pages/MotivosDivergenciaMedia'
import EncerrantesBombas from './pages/EncerrantesBombas'
import ImportacaoExcelAbastecimentos from './pages/ImportacaoExcelAbastecimentos'
import Compras from './pages/Compras'
import ManifestadorDestinatario from './pages/ManifestadorDestinatario'
import ManifestadorCte from './pages/ManifestadorCte'
import ManifestadorNFSeNacional from './pages/ManifestadorNFSeNacional'
import LancamentoNotas from './pages/LancamentoNotas'
import ParametrosSistema from './pages/ParametrosSistema'
import CadastroUsuarios from './pages/CadastroUsuarios'
import LancamentoCte57 from './pages/LancamentoCte57'
import CondicaoPagamento from './pages/CondicaoPagamento'
import Compradores from './pages/Compradores'
import OperacoesComerciais from './pages/OperacoesComerciais'
import NaoConformidades from './pages/NaoConformidades'
import SolicitacaoCompra from './pages/SolicitacaoCompra'
import ConsultaSolicitacaoCompra from './pages/ConsultaSolicitacaoCompra'
import OrdemCompra from './pages/OrdemCompra'
import ConsultaOrdemCompra from './pages/ConsultaOrdemCompra'
import AprovacaoOrdemCompra from './pages/AprovacaoOrdemCompra'
import { EmpresaProvider } from './contexts/EmpresaContext'

// Sessão expira ao fechar o navegador (sessionStorage) e também após 2h sem uso.
const LIMITE_INATIVIDADE_MS = 2 * 60 * 60 * 1000

function sessaoExpirada(): boolean {
  const ultimaAtividade = Number(sessionStorage.getItem('frotaweb_last_activity') || 0)
  return !ultimaAtividade || Date.now() - ultimaAtividade > LIMITE_INATIVIDADE_MS
}

function registrarAtividade() {
  sessionStorage.setItem('frotaweb_last_activity', String(Date.now()))
}

export default function App() {
  const [user, setUser] = useState<string | null>(() => {
    const usuario = sessionStorage.getItem('frotaweb_user')
    if (usuario && sessaoExpirada()) {
      sessionStorage.removeItem('frotaweb_user')
      sessionStorage.removeItem('frotaweb_tiplib')
      return null
    }
    return usuario
  })
  const [tiplib, setTiplib] = useState<number | null>(() => {
    const v = sessionStorage.getItem('frotaweb_tiplib')
    return v ? Number(v) : null
  })

  const [perfil, setPerfil] = useState<string>(() => sessionStorage.getItem('frotaweb_perfil') || 'comum')

  function handleLogin(username: string, tiplib: number | null, perfilLogin: string) {
    sessionStorage.setItem('frotaweb_user', username)
    sessionStorage.setItem('frotaweb_perfil', perfilLogin)
    setPerfil(perfilLogin)
    if (tiplib === null) sessionStorage.removeItem('frotaweb_tiplib')
    else sessionStorage.setItem('frotaweb_tiplib', String(tiplib))
    registrarAtividade()
    setUser(username)
    setTiplib(tiplib)
  }

  function handleLogout() {
    sessionStorage.removeItem('frotaweb_user')
    sessionStorage.removeItem('frotaweb_tiplib')
    sessionStorage.removeItem('frotaweb_perfil')
    sessionStorage.removeItem('frotaweb_last_activity')
    setUser(null)
    setTiplib(null)
    setPerfil('comum')
  }

  // Desloga automaticamente depois de 2h sem interação (mouse/teclado/toque) ou de API.
  useEffect(() => {
    if (!user) return
    const eventos = ['mousedown', 'keydown', 'scroll', 'touchstart']
    eventos.forEach(ev => window.addEventListener(ev, registrarAtividade))
    const intervalo = setInterval(() => {
      if (sessaoExpirada()) handleLogout()
    }, 60_000)
    return () => {
      eventos.forEach(ev => window.removeEventListener(ev, registrarAtividade))
      clearInterval(intervalo)
    }
  }, [user])

  // Telas liberadas na aba Opções do Cadastro de Usuários; null = sem configuração (vale o tiplib).
  // Recarrega quando a própria aba grava (evento 'frotaweb:permissoes').
  const [telasPermitidas, setTelasPermitidas] = useState<Set<string> | null>(null)
  const acessoTotal = perfil === 'master' || perfil === 'super'
  useEffect(() => {
    if (!user || acessoTotal) { setTelasPermitidas(null); return }
    const carregar = () => api.get(`/erp/usuarios/${encodeURIComponent(user)}/permissoes-web`)
      .then(r => setTelasPermitidas(r.data?.configurado
        ? new Set(Object.entries(r.data.perms as Record<string, { a: boolean }>).filter(([, p]) => p.a).map(([tela]) => tela))
        : null))
      .catch(() => setTelasPermitidas(null))
    carregar()
    window.addEventListener('frotaweb:permissoes', carregar)
    return () => window.removeEventListener('frotaweb:permissoes', carregar)
  }, [user, acessoTotal])

  if (!user) {
    return <LoginPage onLogin={handleLogin} />
  }

  const acessoLimitado = !acessoTotal && tiplib === 6
  const apenasVendas = !acessoTotal && tiplib === 5

  return (
    <EmpresaProvider>
    <Layout user={user} onLogout={handleLogout} acessoLimitado={acessoLimitado} apenasVendas={apenasVendas} telasPermitidas={telasPermitidas}>
      <Routes>
        <Route path="/" element={<Principal acessoLimitado={acessoLimitado} apenasVendas={apenasVendas} telasPermitidas={telasPermitidas} />} />
        <Route path="/nfe/emitir" element={<EmitirNFe />} />
        <Route path="/nfe/lista" element={<ListaNFe />} />
        <Route path="/nfe/devolucao" element={<EmitirDevolucaoNFe />} />
        <Route path="/nfe/nota-credito" element={<EmitirNotaCreditoNFe />} />
        <Route path="/nfe/nota-debito" element={<EmitirNotaDebitoNFe />} />
        <Route path="/nfe/aceite-debito" element={<AceiteDebitoNFe />} />
        <Route path="/cte/emitir" element={<EmitirCTeOS />} />
        <Route path="/cte/lista" element={<ListaCTeOS />} />
        <Route path="/cte/consultar" element={<ListaCTeOS />} />
        <Route path="/documents/:empCod/:serie/:numero" element={<DocumentDetail />} />
        <Route path="/nfse/emitir" element={<EmitirNFSe />} />
        <Route path="/nfse/locacao" element={<EmitirNFSeLocacao />} />
        <Route path="/nfse/lista" element={<ListaNFSeNacional />} />
        <Route path="/nfse/servicos" element={<CadastroServicosNFSe />} />
        <Route path="/nfse/tributacao-municipal" element={<CadastroTributacaoMunicipalNFSe />} />
        <Route path="/nfse-infisc/emitir" element={<EmitirNFSeInfisc />} />
        <Route path="/nfse-infisc/lista" element={<ListaNFSeInfisc />} />
        <Route path="/relatorios/nfe-saida" element={<RelatorioNfeSaida />} />
        <Route path="/relatorios/faturamento" element={<RelatorioFaturamento />} />
        <Route path="/relatorios/issqn" element={<RelatorioIssqn />} />
        <Route path="/relatorios/faturamento-cliente" element={<RelatorioFaturamentoCliente />} />
        <Route path="/relatorios/evolucao-faturamento" element={<RelatorioEvolucaoFaturamento />} />
        <Route path="/relatorios/contas-receber" element={<RelatorioContasReceber />} />
        <Route path="/relatorios/download-lote" element={<DownloadLoteNotas />} />
        <Route path="/configuracoes" element={<Configuracoes />} />
        <Route path="/configuracoes/clientes" element={<CadastroClientes />} />
        <Route path="/configuracoes/naturezas" element={<NaturezasOperacao />} />
        <Route path="/sistema/log" element={<LogSistema />} />
        <Route path="/administracao/parametros" element={<ParametrosSistema />} />
        <Route path="/administracao/usuarios" element={<CadastroUsuarios />} />
        <Route path="/configuracoes/reforma-tributaria" element={<ReformaTributaria />} />
        <Route path="/configuracoes/tributacoes" element={<Tributacoes />} />
        <Route path="/funcionarios" element={<Navigate to="/funcionarios/cadastro" replace />} />
        <Route path="/funcionarios/cadastro" element={<CadastroFuncionarios />} />
        <Route path="/funcionarios/consulta" element={<CadastroFuncionarios key="consulta" consulta />} />
        <Route path="/funcionarios/importar-despesas" element={<ImportarDespesasFuncionarios />} />
        <Route path="/funcionarios/planos-saude" element={<CadastroPlanosSaude />} />
        <Route path="/funcionarios/certificados-registros" element={<CertificadosRegistros />} />
        <Route path="/funcionarios/ficha-ponto" element={<FichaPonto />} />
        <Route path="/funcionarios/ficha-ponto/nova" element={<NovaFichaPonto />} />
        <Route path="/funcionarios/ficha-ponto/lote" element={<AbrirFichasLote />} />
        <Route path="/funcionarios/ficha-ponto/importar-lote" element={<ImportarBusrepLote />} />
        <Route path="/funcionarios/ficha-ponto/excluir-lote" element={<ExcluirFichasLote />} />
        <Route path="/funcionarios/ficha-ponto/imprimir-lote" element={<ImprimirFichasLote />} />
        <Route path="/funcionarios/ficha-ponto/:ano/:mes/:colaborador" element={<CartaoPontoDias />} />
        <Route path="/funcionarios/configuracoes/parametros-ficha-ponto" element={<ParametrosFichaPonto />} />
        <Route path="/funcionarios/configuracoes/tipos-jornada" element={<TiposJornada />} />
        <Route path="/funcionarios/configuracoes/colaboradores" element={<CadastroColaboradores />} />
        <Route path="/funcionarios/configuracoes/categorias-cnh" element={<CategoriasCnh />} />
        <Route path="/funcionarios/configuracoes/ocorrencias" element={<Ocorrencias />} />
        <Route path="/funcionarios/configuracoes/afastamentos" element={<Afastamentos />} />
        <Route path="/funcionarios/configuracoes/locais-escala" element={<LocaisEscala />} />
        <Route path="/funcionarios/configuracoes/categorias-profissionais" element={<CategoriasProfissionais />} />
        <Route path="/funcionarios/relatorios/funcionarios" element={<RelatorioFuncionarios />} />
        <Route path="/funcionarios/relatorios/afastados" element={<RelatorioFuncionariosAfastados />} />
        <Route path="/funcionarios/relatorios/salarios-atuais" element={<RelatorioSalariosAtuais />} />
        <Route path="/funcionarios/relatorios/gerador" element={<GeradorRelatorios />} />
        <Route path="/funcionarios/relatorios/aniversariantes" element={<RelatorioAniversariantes />} />
        <Route path="/funcionarios/documentos/painel-vencimentos" element={<PainelVencimentosFuncionarios />} />
        <Route path="/funcionarios/documentos/validade-exames" element={<RelatorioValidadeExames />} />
        <Route path="/funcionarios/documentos/controle-ferias" element={<ControleFerias />} />
        <Route path="/funcionarios/documentos/calendario-ferias" element={<CalendarioFerias />} />
        <Route path="/funcionarios/documentos/vencimento-cnh" element={<RelatorioVencimentoCnh />} />
        <Route path="/funcionarios/documentos/vencimento-certificados" element={<RelatorioVencimentoCertificados />} />
        <Route path="/funcionarios/ocorrencias/lancamento" element={<LancamentoOcorrencias />} />
        <Route path="/funcionarios/ocorrencias/consulta" element={<LancamentoOcorrencias key="consulta" consulta />} />
        <Route path="/funcionarios/ocorrencias/excluir" element={<ExcluirOcorrencias />} />
        <Route path="/funcionarios/relatorios/custos-plano-saude" element={<RelatorioCustoPlanoSaude />} />
        <Route path="/combustiveis" element={<PainelCombustivel />} />
        <Route path="/combustiveis/lancamento-depositos" element={<LancamentoDepositos />} />
        <Route path="/combustiveis/lancamento-arla-deposito" element={<LancamentoDepositos key="arla" arla />} />
        <Route path="/combustiveis/lancamentos-externos" element={<LancamentosExternos />} />
        <Route path="/combustiveis/lancamento-arla-externo" element={<LancamentosExternos key="arla" arla />} />
        <Route path="/combustiveis/atualizacoes/lancamentos-veiculo" element={<AtualizarLancamentosVeiculo />} />
        <Route path="/combustiveis/atualizacoes/lancamentos-arla" element={<AtualizarLancamentosVeiculo key="arla" arla />} />
        <Route path="/combustiveis/saldos" element={<SaldoTanques />} />
        <Route path="/combustiveis/saldos/encerrantes" element={<EncerrantesBombas />} />
        <Route path="/combustiveis/atualizacoes/cta-plus" element={<IntegracaoCtaPlus />} />
        <Route path="/combustiveis/atualizacoes/corrige-importacao" element={<CorrigeLancamentosImportacao />} />
        <Route path="/combustiveis/relatorios/consumo-arla" element={<RelatorioConsumoArla />} />
        <Route path="/combustiveis/relatorios/consumo-frota" element={<RelatorioConsumoFrota />} />
        <Route path="/combustiveis/relatorios/media-combustivel" element={<RelatorioMediaCombustivel />} />
        <Route path="/combustiveis/relatorios/lancamentos-dia" element={<RelatorioLancamentosDia />} />
        <Route path="/combustiveis/relatorios/consumo-mensal" element={<RelatorioConsumoMensalVeiculo />} />
        <Route path="/combustiveis/relatorios/consumo-posto" element={<RelatorioConsumoPosto />} />
        <Route path="/combustiveis/relatorios/abastecedor" element={<RelatorioAbastecedor />} />
        <Route path="/combustiveis/relatorios/desvio-consumo" element={<RelatorioDesvioConsumo />} />
        <Route path="/combustiveis/parametros/combustiveis" element={<CadastroCombustiveis />} />
        <Route path="/combustiveis/parametros/postos" element={<CadastroPostos />} />
        <Route path="/combustiveis/parametros/layout-postos" element={<LayoutPostos />} />
        <Route path="/combustiveis/parametros/motivos-divergencia" element={<MotivosDivergenciaMedia />} />
        <Route path="/combustiveis/importacoes/excel" element={<ImportacaoExcelAbastecimentos />} />
        <Route path="/compras" element={<Compras />} />
        <Route path="/compras/manifestacao/nfe" element={<ManifestadorDestinatario />} />
        <Route path="/compras/manifestacao/cte" element={<ManifestadorCte />} />
        <Route path="/compras/manifestacao/nfse" element={<ManifestadorNFSeNacional />} />
        <Route path="/compras/recebimentos/lancamento-notas" element={<LancamentoNotas key="55" />} />
        <Route path="/compras/recebimentos/lancamento-nfse99" element={<LancamentoNotas key="99" modeloFixo="99" />} />
        <Route path="/compras/recebimentos/lancamento-cte57" element={<LancamentoCte57 />} />
        <Route path="/compras/recebimentos/importar-nfe" element={<ImportarNFe />} />
        <Route path="/compras/recebimentos/importar-cte" element={<ImportarCTe />} />
        <Route path="/compras/devolucao" element={<EmitirDevolucaoNFe />} />
        <Route path="/compras/consultas/notas" element={<ConsultaNotas />} />
        <Route path="/compras/consultas/itens" element={<ConsultaItens />} />
        <Route path="/compras/parametros/condicao-pagamento" element={<CondicaoPagamento />} />
        <Route path="/compras/parametros/compradores" element={<Compradores />} />
        <Route path="/compras/parametros/clientes" element={<CadastroClientes />} />
        <Route path="/compras/parametros/operacoes-comerciais" element={<OperacoesComerciais />} />
        <Route path="/compras/parametros/nao-conformidades" element={<NaoConformidades />} />
        <Route path="/compras/ajustes-fiscais/estorno-nota" element={<EstornoNotaFiscal />} />
        <Route path="/compras/ajustes-fiscais/alterar-data" element={<AlterarDataNotaFiscal />} />
        <Route path="/compras/ajustes-fiscais/alterar-cfop" element={<AlterarCfopNotaFiscal />} />
        <Route path="/compras/ajustes-fiscais/alterar-aplicacao" element={<AlterarAplicacaoNotaFiscal />} />
        <Route path="/compras/utilitarios/codigos-barras" element={<EmissaoCodigosBarras />} />
        <Route path="/compras/utilitarios/gravar-xml-nfe" element={<GravarXmlNFe />} />
        <Route path="/compras/relatorios/notas-recebimento-emissao" element={<RelatorioNotasComprasRecebimentoEmissao />} />
        <Route path="/compras/relatorios/notas-imposto-retido" element={<RelatorioNotasImpostoRetido />} />
        <Route path="/compras/relatorios/notas-entrada" element={<RelatorioNotasEntrada />} />
        <Route path="/compras/relatorios/itens-devolvidos" element={<RelatorioItensDevolvidos />} />
        <Route path="/compras/solicitacao" element={<SolicitacaoCompra />} />
        <Route path="/compras/solicitacao/consulta" element={<ConsultaSolicitacaoCompra />} />
        <Route path="/compras/ordem-compra" element={<OrdemCompra />} />
        <Route path="/compras/ordem-compra/consulta" element={<ConsultaOrdemCompra />} />
        <Route path="/compras/ordem-compra/aprovacao" element={<AprovacaoOrdemCompra />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </Layout>
    </EmpresaProvider>
  )
}
